<template>
  <div>
    <b-button :disabled="isLoading" variant="outline-primary" @click="() => showList()">
      {{ btnCaption }}
    </b-button>
    <b-modal
      id="videoList"
      title-class="w-75"
      header-close-content=""
      centered
      @ok="onInput"
      @hide="showIframeIds = []"
      :ok-only="!list.length"
      :ok-title="!list.length ? 'Добавить' : 'ОК'"
      cancel-title="Отмена"
    >
      <template #modal-title>
        <div class="d-flex align-items-center">
          <div class="col-lg-4 col-6 d-flex align-items-center">
            <span>
              {{ modalTitle }}
            </span>
            <b-spinner v-if="isLoading" small variant="primary" class="ml-2" />
          </div>
          <input-delay v-model="search" @input="load" />
        </div>
      </template>
      <scrollable-content class="video-container d-flex flex-wrap" @scroll-end="load">
        <template #content>
          <span v-if="!list.length && !isLoading">Загруженных видеофайлов не найдено</span>
          <div v-else class="col-4 mb-4" v-for="v in list" :key="v.id">
            <div class="embed-container">
              <iframe allowfullscreen v-if="~showIframeIds.indexOf(v.id)" :src="v.iframe_src" frameborder="0" />
              <img v-else-if="v.preview_src" :src="v.preview_src" @click="showIframeIds.push(v.id)" />
              <span v-else class="d-flex align-items-center justify-content-center border"
                >Это видео ещё не загрузилось</span
              >
            </div>
            <div class="video-title d-flex align-items-center mb-2">
              <label class="font-weight-bold p-2 d-flex flex-grow-1 mb-0" :title="v.name.length > 25 && v.name">
                <b-form-checkbox v-model="selectedVideo" :value="v" />
                {{ v.name.slice(0, 25) + ((v.name.length > 25 && "...") || "") }}
              </label>
              <a v-if="v.download_link" :href="v.download_link" title="Скачать">
                <i class="flaticon-download"></i>
              </a>
            </div>
          </div>
        </template>
      </scrollable-content>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.btn-outline-primary {
  width: 100%;
}
</style>

<style lang="scss">
#videoList {
  .modal-dialog {
    max-width: 900px !important;
    .video-container {
      height: 450px;
      overflow-y: scroll;
    }
  }
  .video-title {
    label {
      cursor: pointer;
    }
  }
  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    overflow: hidden;
    max-width: 100%;
    height: auto;
    iframe,
    img,
    span {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<script>
import InputDelay from 'shared/widgets/InputDelay.vue';
import ScrollableContent from 'shared/widgets/ScrollableContent.vue';
import { mapActions, mapState } from "vuex";

export default {
  name: "ProjectVideoList",
  components: { InputDelay, ScrollableContent },
  props: {
    btnCaption: {
      type: String,
      default: "Использовать загруженное",
    },
    modalTitle: {
      type: String,
      default: "Загруженные видео",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedVideo: (this.multiple && []) || null,
      showIframeIds: [],
      search: this.searchLast,
    };
  },
  computed: {
    ...mapState("autocomplete/video", ["searchLast", "list", "isLoading", "isLoaded"]),
  },
  methods: {
    ...mapActions("autocomplete/video", ['loadList']),
    load() {
      this.loadList({ search: this.search });
    },
    showList() {
      !this.list.length && this.load();
      this.$bvModal.show("videoList");
    },
    onInput() {
      this.$emit("input", this.selectedVideo);
      this.selectedVideo = (this.multiple && []) || null;
    },
  },
  mounted() {
    this.search = this.searchLast;
  },
};
</script>
